import { currentBrowserInfo } from "../BrowserInfo";

/**
 * List of KeyboardEvent keys.
 * Extracted from https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values
 */
export namespace Keyboard {
    export const UP: string = currentBrowserInfo.isEdge ? "Up" : "ArrowUp";
    export const DOWN: string = currentBrowserInfo.isEdge ? "Down" : "ArrowDown";
    export const LEFT: string = currentBrowserInfo.isEdge ? "Left" : "ArrowLeft";
    export const RIGHT: string = currentBrowserInfo.isEdge ? "Right" : "ArrowRight";
    export const INSERT: string = "Insert";
    export const DELETE: string = "Delete";
    export const HOME: string = "Home";
    export const END: string = "End";
    export const PAGEUP: string = "PageUp";
    export const PAGE_UP: string = PAGEUP;
    export const PAGEDOWN: string = "PageDown";
    export const PAGE_DOWN: string = PAGEDOWN;
    export const PRINTSCREEN: string = "PrintScreen";
    export const SCROLLLOCK: string = "ScrollLock";
    export const PAUSE: string = "Pause";
    export const BREAK: string = "Pause";
    export const PRINT: string = "Print";
    export const SHIFT: string = "Shift";
    export const SPACE: string = " ";
    export const SPACEBAR: string = SPACE;
    export const TAB: string = "Tab";
    export const BACKSPACE: string = "Backspace";
    export const CONTROL: string = "Control";
    export const ALTERNATE: string = "Alt";
    export const ALT: string = "Alt";
    export const ALTGRAPH: string = "AltGraph";
    export const ENTER: string = "Enter";
    export const ESCAPE: string = "Escape";
    export const ESC: string = ESCAPE;

    export const NUMBER_0: string = "0";
    export const NUMBER_1: string = "1";
    export const NUMBER_2: string = "2";
    export const NUMBER_3: string = "3";
    export const NUMBER_4: string = "4";
    export const NUMBER_5: string = "5";
    export const NUMBER_6: string = "6";
    export const NUMBER_7: string = "7";
    export const NUMBER_8: string = "8";
    export const NUMBER_9: string = "9";

    export const A: string = "a";
    export const B: string = "b";
    export const C: string = "c";
    export const D: string = "d";
    export const E: string = "e";
    export const F: string = "f";
    export const G: string = "g";
    export const H: string = "h";
    export const I: string = "i";
    export const J: string = "j";
    export const K: string = "k";
    export const L: string = "l";
    export const M: string = "m";
    export const N: string = "n";
    export const O: string = "o";
    export const P: string = "p";
    export const Q: string = "q";
    export const R: string = "r";
    export const S: string = "s";
    export const T: string = "t";
    export const U: string = "u";
    export const V: string = "v";
    export const W: string = "w";
    export const X: string = "x";
    export const Y: string = "y";
    export const Z: string = "z";

    export const F1: string = "F1";
    export const F2: string = "F2";
    export const F3: string = "F3";
    export const F4: string = "F4";
    export const F5: string = "F5";
    export const F6: string = "F6";
    export const F7: string = "F7";
    export const F8: string = "F8";
    export const F9: string = "F9";
    export const F10: string = "F10";
    export const F11: string = "F11";
    export const F12: string = "F12";
    export const F13: string = "F13";
    export const F14: string = "F14";
    export const F15: string = "F15";

    export const NUMPAD: string = "NumLock";
    export const NUMPAD_0: string = NUMBER_0;
    export const NUMPAD_1: string = NUMBER_1;
    export const NUMPAD_2: string = NUMBER_2;
    export const NUMPAD_3: string = NUMBER_3;
    export const NUMPAD_4: string = NUMBER_4;
    export const NUMPAD_5: string = NUMBER_5;
    export const NUMPAD_6: string = NUMBER_6;
    export const NUMPAD_7: string = NUMBER_7;
    export const NUMPAD_8: string = NUMBER_8;
    export const NUMPAD_9: string = NUMBER_9;
    export const NUMPAD_ADD: string = "+";
    export const NUMPAD_DIVIDE: string = "/";
    export const NUMPAD_ENTER: string = ENTER;
    export const NUMPAD_MULTIPLY: string = "*";
    export const NUMPAD_SUBTRACT: string = "-";
    export const NUMPAD_DECIMAL: string = ".";

    export const COLON: string = ":";
    export const EQUALS: string = "=";
    export const UNDERSCORE: string = "_";
    export const QUESTION_MARK: string = "?";
    export const TILDE: string = "~";
}
